// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__JnaVO","text":"Button_text__N0g-B"};